import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { ButtonProps } from '#components/BottomActions'
import type { ViewState } from '#components/Root/viewModel'
import type { Transitioner } from '#components/TransitionProvider'
import type { Nodes } from '#models/Nodes'

import * as mobx from 'mobx'
import PT from 'prop-types'

export type Props = {
  state: ViewState
}

export type ViewModel = {
  showButtons: boolean
  showContinue: boolean
  showBack: boolean
  buttons: Array<ButtonProps>

  handleNext: () => void
  _handleClick: (number) => () => void
}

type Context = {
  models: { nodes: Nodes }
  transitioner: Transitioner
}

const mkViewModel = (
  params: Params,
  { state }: Props,
  { transitioner }: Context,
): ViewModel => {
  const vm = mobx.observable({
    get showButtons() {
      return vm.showContinue || vm.showBack
    },
    get buttons() {
      return state.currentNode && state.currentNode.options
        ? state.currentNode.options.map((option) => ({
            highlighted: option.highlighted,
            handleClick: vm._handleClick(option.id),
            text: option.text,
            subtext: option.subtext,
          }))
        : null
    },
    get showContinue() {
      return state.currentNode && state.currentNode.nextNode
    },
    get showBack() {
      return state.currentNode && state.currentNode.allowBack
    },

    handleNext: mobx.action(() => {
      const nextNodeId =
        state.currentNode &&
        state.currentNode.nextNode &&
        state.currentNode.nextNode.id
      if (nextNodeId) transitioner.goForward(nextNodeId)
    }),
    _handleClick: mobx.action((id) => () => {
      const option =
        state.currentNode &&
        state.currentNode.options &&
        state.currentNode.options.find((op) => op.id === id)
      if (option && option.externalLink) {
        transitioner.openExternal(option.externalLink)
      } else if (option && option.link) {
        transitioner.goForward(option.link.id)
      }
    }),
  })

  return vm
}

mkViewModel.contextTypes = {
  transitioner: PT.object.isRequired,
}

export default mkViewModel
